// @flow

import {MenuItem, makeStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {colors} from '../../../../../assets/styles/colors';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {useOutsideAlerter} from '../../../../../utils/dom';

import type {Node} from 'react';
import type {ProductVariantOption} from '../../../../../entities';

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${colors.grey300}`,
    borderRadius: '10px',
    padding: theme.spacing(1.6, 1),
    height: 52,
    position: 'relative',
    cursor: 'pointer',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionsWrap: {
    width: '100%',
    zIndex: 10,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    position: 'absolute',
    top: 52,
    left: 0,
    flexDirection: 'column',
    border: `1px solid ${colors.grey300}`,
    height: 220,
    // maxHeight: 220,
    transition: 'all 0.3s ease-in-out',
    // overflowY: 'auto',
  },
  menuItem: {
    height: 30,
  },
}));

type Props = {
  options?: ProductVariantOption[],
  hiddenOptions?: string[],
  value: string,
  onSelectOption: ProductVariantOption => void,
  children?: (args: any) => Node,
  openCallback?: () => void,
  label?: string,
  placeholder?: string,
};

export default function CustomOptionSelect({
  value,
  options = [],
  hiddenOptions = [],
  onSelectOption,
  children,
  openCallback,
  label,
}: Props) {
  const classes = useStyles();
  const {isOutside, ref} = useOutsideAlerter();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleSelect = () => {
    if (!isOpen) setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  const handleSelectOption = (o: ProductVariantOption) => {
    onSelectOption(o);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOutside) setIsOpen(false);
  }, [isOutside]);

  useEffect(() => {
    if (isOpen) {
      if (openCallback) openCallback();
    }

    // eslint-disable-next-line
  }, [isOpen]);

  return (
    <div
      role="button"
      ref={ref}
      className={classes.root}
      onClick={toggleSelect}
      aria-label={label ?? 'custom-option-select'}
    >
      <div className={classes.header}>
        <div>{value || 'Selecciona una opción'}</div>
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
      {isOpen && (
        <>
          <div className={classes.optionsWrap}>
            <div
              style={{
                position: 'relative',
                maxHeight: '170px',
                overflowY: 'auto',
              }}
            >
              {options?.map(o => {
                if (hiddenOptions.includes(o.label)) return null;
                return (
                  <MenuItem
                    className={classes.menuItem}
                    key={o.label}
                    onClick={() => handleSelectOption(o)}
                  >
                    {o.label}
                  </MenuItem>
                );
              })}
            </div>
          </div>
          {children?.({handleClose})}
        </>
      )}
    </div>
  );
}
